import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import RequirementBlockCardHeader from '../RequirementBlockCardHeader';

const InsuranceDocumentBlock = ({ displayName, description, isArchived, isRequired, relatedQuestions }) => (
  <Box
    backgroundColor={colors.primaryScale['50']}
    borderRadius="md"
    flexBasis="100%"
    mb={4}
    px={3}
    py={4}
  >
    <RequirementBlockCardHeader
      displayName={displayName}
      isArchived={isArchived}
      isRequired={isRequired}
      relatedQuestions={relatedQuestions}
    />
    {description && (
      <Text
        color={colors.greyScale['700']}
        mt={2}
        textAlign="left"
        textStyle="bodySm"
      >
        {description}
      </Text>
    )}
  </Box>
);

InsuranceDocumentBlock.propTypes = {
  displayName: PropTypes.string,
  description: PropTypes.string,
  isArchived: PropTypes.bool,
  isRequired: PropTypes.bool,
  relatedQuestions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    question: PropTypes.string
  }))
};

export default InsuranceDocumentBlock;
